export const CHECK_LOGIN = 'check_login';
export const LOGIN_USER_SUCCESSFUL = 'login_user_successfull';
export const LOGIN_USER_SUCCESSFUL_WITH_QR_CODE = 'login_user_successful_with_qr_code';
export const LOGIN_USER_SUCCESSFUL_WITH_VERIFICATION = 'login_user_successful_with_verification';

export const VERIFY_TOTP = 'verify_totp';
export const VERIFY_TOTP_SUCCESSFUL = 'verify_totp_successful';

export const LOGOUT_USER = 'LOGOUT_USER';
export const FORCE_LOGOUT = 'FORCE_LOGOUT';
export const LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS';

export const API_ERROR = 'api_failed';

export const CLEAR_ALL_LOGIN_MESSAGES = 'clear_all_login_messages';
export const CLEAR_ALL_LOGIN_MESSAGES_SUCCESSFUL = 'clear_all_login_messages_successful';
